var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "135.229 169.906 226.086 202.434",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 248.223,
    y1: 172.201,
    x2: 248.223,
    y2: 370.157,
    id: "gradient-0",
    gradientTransform: "matrix(0.705364, -0.708844, 0.931277, 0.926705, -168.289676, 195.068439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 216, 123)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255, 182, 7)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 174.983 173.558 C 173.333 174.278 170.285 176.623 168.209 178.769 C 164.656 182.443 143.162 216.573 139.616 224.171 C 138.16 227.293 137.983 234.481 137.983 290.671 C 137.983 349.883 138.094 353.894 139.827 357.378 C 142.28 362.311 146.108 366.056 150.983 368.292 C 154.771 370.03 159.927 370.128 248.265 370.149 C 350.316 370.173 345.374 370.449 351.859 364.368 C 353.441 362.885 355.569 359.871 356.587 357.671 C 358.327 353.914 358.44 349.865 358.461 290.889 C 358.48 237.296 358.263 227.581 356.982 224.515 C 354.618 218.857 332.516 183.04 329.08 179.299 C 323.124 172.814 320.429 172.212 297.483 172.239 L 276.983 172.262 L 288.349 183.217 L 299.715 194.171 L 307.924 194.171 L 316.132 194.171 L 325.287 210.421 L 334.441 226.671 L 248.801 226.927 C 201.699 227.067 162.96 226.981 162.714 226.735 C 162.468 226.489 166.399 219.062 171.449 210.23 L 180.632 194.171 L 188.808 194.134 L 196.983 194.097 L 208.483 183.171 L 219.983 172.245 L 198.983 172.247 C 183.88 172.249 177.141 172.617 174.983 173.558 M 233.703 182.081 C 227.807 187.532 217.59 197.432 210.999 204.081 L 199.014 216.171 L 247.749 216.171 C 275.948 216.171 296.483 215.792 296.483 215.271 C 296.483 214.777 293.895 212.008 290.733 209.12 C 287.571 206.231 277.474 196.736 268.297 188.02 C 247.109 167.895 248.744 168.176 233.703 182.081",
    stroke: "none",
    fillRule: "evenodd",
    style: {
      fill: "url(#gradient-0)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.692,
    y: 321.023,
    width: 80.363,
    height: 11.644,
    rx: 1,
    ry: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      paintOrder: "stroke",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.787,
    y: 320.96,
    width: 17.214,
    height: 11.673,
    rx: 1,
    ry: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      paintOrder: "stroke",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)"
    },
    d: "M 195.701 254.434 C 195.701 254.434 200.619 249.435 210.142 249.593 C 222.919 249.804 225.991 257.992 225.991 257.992 C 225.991 257.992 233.061 249.385 242.682 249.325 C 257.545 249.232 262.088 259.246 262.072 266.268 C 262.044 278.39 261.851 310.967 261.851 310.967 L 248.375 310.898 L 248.374 269.709 C 248.374 269.709 249.726 261.253 241.853 261.249 C 235.433 261.245 229.102 265.117 229.107 269.346 C 229.12 280.558 228.79 311.158 228.79 311.158 L 214.467 311.043 L 214.735 269.343 C 214.735 269.343 215.842 261.033 207.728 260.994 C 199.621 260.955 195.595 266.181 195.589 268.662 C 195.554 282.177 195.297 311.304 195.297 311.304 L 181.506 311.329 L 181.542 250.042 L 195.636 250.155 L 195.701 254.434 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)"
    },
    d: "M 266.757 251.065 L 289.013 309.854 C 289.013 309.854 286.751 317.764 283.562 319.787 C 280.393 321.798 272.324 320.483 272.324 320.483 L 272.062 333.388 C 272.062 333.388 276.484 334.67 278.762 334.763 C 281.065 334.857 283.484 334.782 285.625 333.93 C 288.314 332.86 290.696 330.943 292.605 328.768 C 295.21 325.8 298.356 318.409 298.356 318.409 L 323.773 251.257 L 309.274 251.231 L 295.546 292.857 L 281.66 251.002 L 266.757 251.065 Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7639ee7a321895cf4b071a475b43ee2e.svg";
export { ForwardRef as ReactComponent };